import mixpanel from "mixpanel-browser";
import { useEffect } from "react";
import type { RootLoaderData } from "~/root";
import { clientEnv } from ".env/.browser";

const MIXPANEL_EVENTS = {
  ACT_APPLICATION_SELECTED_UNIT: "User Selected a Unit to apply on",
  ACT_APPLICATION_VERIFY_EMAIL: "User Requested Email Verification",
  NAV_APPLICATION_APPLY_STEP: "Navigated to Apply Step",
  NAV_APPLICATION_APPLICATION_TYPE_STEP: "Navigvated to Application Type Step",
  NAV_APPLICATION_PERSONAL_STEP: "Navigated to Personal Step",
  NAV_APPLICATION_DOCUMENT_STEP: "Navigated to Document Step",
  NAV_APPLICATION_CONSENT_STEP: "Navigated to Consent Step",
  NAV_APPLICATION_CREDIT_CHECK_STEP: "Navigated to Credit Check Step",
  NAV_APPLICATION_PAYMENT_STEP: "Navigated to Payment Step",
  NAV_APPLICATION_CUSTOM_STEP: "Navigated to Custom Step",
  NAV_APPLICATION_COMPLETE_STEP: "Navigated to Complete Step",
  NAV_TENANT_PORTAL: "Navigated to Tenant Portal",
  NAV_APPLICATION_VERIFIED_USER: "User is Verified",
  NAV_LISTING_DETAILS: "Navigated to a Listing",
  NAV_LISTING_FAVORITES: "Navigated to the Favorites",
  NAV_APPLICATION_REFERENCES_STEP: "Navigated to References Step",
};

type MIXPANEL_EVENTS = keyof typeof MIXPANEL_EVENTS;

let isMixpanelInit = false;

const isEnabled = () => {
  return !!clientEnv.CLIENT_MIXPANEL_PROJECT_ID;
};

const initialize = () => {
  if (!isEnabled()) return;
  if (isMixpanelInit) return;

  if (!clientEnv.CLIENT_MIXPANEL_PROJECT_ID) {
    return;
  }

  isMixpanelInit = true;
  mixpanel.init(clientEnv.CLIENT_MIXPANEL_PROJECT_ID, {
    track_pageview: false,
    persistence: "localStorage",
  });
};

export const useMixpanelIdentify = (user: RootLoaderData["user"] | undefined | null) => {
  useEffect(
    function identifyMixpanel() {
      if (!isEnabled()) return;
      if (!user?.userId || !user.fullName || !user?.email) return;

      initialize();
      mixpanel.identify(user.userId);
      mixpanel.people.set({ $name: user.fullName, $email: user.email });
    },
    [user],
  );
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const useMixpanelTrack = (event: MIXPANEL_EVENTS, props?: Record<string, any>) => {
  useEffect(function trackMixpanelEvent() {
    if (!isEnabled()) return;
    initialize();
    trackEvent(event, props);
  }, []);
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const trackEvent = (event: MIXPANEL_EVENTS, props?: Record<string, any>) => {
  if (!isEnabled()) return;
  initialize();
  mixpanel.track(MIXPANEL_EVENTS[event], props);
};
